module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_a-function.js
// module id = ../../../../core-js/library/modules/_a-function.js
// module chunks = 7